import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {tags} from "@signals";

const TAG_OPTIONS = [
    { label: "Discount", value: 2 },
    { label: "Empty", value: 0 },
    { label: "GWP", value: 3 },
    { label: "Promocode", value: 1 }
]

export default function CommonFiltersBannerTagsSelect({ ...props }) {
    return <SelectSeeker
        multiple
        options={TAG_OPTIONS}
        label="All tags"
        placeholder="All tags"
        value={tags.value}
        onChange={e => tags.value = e.target.value}
        {...props}
    />
}